import {FC, useEffect, useState} from "react"
import {Box, CircularProgress, Typography} from "@mui/material"
import {
  RequestQueueFailedIcon,
  RequestQueueInProgressIcon,
  RequestQueueSuccessIcon,
} from "../../../assets/icons/icons"

type Props = {
  isInProgress: boolean
  isSuccess: boolean
  isFailed: boolean
}

const RequestsQueueProgress: FC<Props> = (props) => {
  const {isInProgress, isFailed, isSuccess} = props
  const [color, setColor] = useState<string>("#226ca5")
  const colors = {
    successful: "#58a733",
    failed: "#db0d00",
    inProgress: "#226ca5",
  }

  useEffect(() => {
    if (isFailed) return setColor(colors.failed)

    if (isSuccess) return setColor(colors.successful)

    if (isInProgress) return setColor(colors.inProgress)

    setColor(colors.successful)
  }, [isFailed, isInProgress, isSuccess])

  return (
    <Box position="relative">
      <CircularProgress
        sx={{
          color: color,
        }}
        variant={isInProgress ? "indeterminate" : "determinate"}
        value={100}
        size={24}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          sx={{
            color: color,
            div: {
              width: "1.25rem",
              height: "1.25rem",
            },
            svg: {
              color: color,
              width: "1.25rem",
              height: "1.25rem",
              fill: "#242D35",
            },
          }}
        >
          {isFailed ? (
            <RequestQueueFailedIcon />
          ) : isSuccess ? (
            <RequestQueueSuccessIcon />
          ) : (
            <RequestQueueInProgressIcon />
          )}
        </Typography>
      </Box>
    </Box>
  )
}

export default RequestsQueueProgress
